import { BaseService } from './base-service';
export class SettingsService {
    static fetchCustomizableRegionSettings() {
        return BaseService.get(`customizable-region-settings`);
    }
    static saveCustomizableRegionSettings(dto) {
        return BaseService.save(`customizable-region-settings`, dto);
    }
}
